import { CompanyTitledPage } from '../../TitledPage';
import { SubTitle } from './component/SubTitle';
import { Content } from './component/ContentInput';
import { useModeID } from './hook/GetModeID';
import { validationSchema } from './component/ValidationSchema';
import { selectUserById, insertUser, updateUser } from "../../../http/api/UserApi";
import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";

import * as Yup from "yup";

export default function UserEditPage() {
  const navigate = useNavigate();
  const { screenMode, userId } = useModeID();
  const [saveCondition , setSaveCondition] = useState({
    loginId: null,
    password: null,
    passAgain: null,
    name: null,
    kana: null,
    type: null,
    customer: null,
    shop: null,
    note: null
  })

  const [errors , setErrors] = useState({
    loginId: '',
    password: '',
    passAgain: '',
    name: '',
    type: '',
    customer: '',
    shop: ''
  })

  useEffect(() => {
    if (screenMode === 2) {
      search(userId);
    }
  }, [screenMode, userId]);

  // 更新・初期表示 ----------------------------------------------------
  async function search (userId) {
    try{
      const res = await selectUserById({userId: userId});
      if (res.userInfo && res.userInfo.user && res.userInfo.user.length > 0) {
        const user = res.userInfo.user[0];
        setSaveCondition({
          loginId: user.loginId,
          password: '・・・・',
          passAgain: '・・・・',
          name: user.name,
          kana: user.kana,
          type: user.type,
          customer: user.customer,
          shop: user.shop,
          note: user.note
        })
      } else {
        setSaveCondition({
          loginId: null,
          password: null,
          passAgain: null,
          name: null,
          kana: null,
          type: null,
          customer: null,
          shop: null,
          note: null
      })
      }
    } catch {
      setSaveCondition({
        loginId: null,
        password: null,
        passAgain: null,
        name: null,
        kana: null,
        type: null,
        customer: null,
        shop: null,
        note: null
      })
    }
  };

  // バリデーションチェック--------------------------------------------
  async function validateData(data, field) {
    try {
      const schema = field ? 
        Yup.object({ [field]: validationSchema(userId).fields[field] }) : 
        validationSchema(userId);
      
      await schema.validate(data, { abortEarly: false });
      setErrors(prevErrors => ({
        ...prevErrors,
        [field]: ""
      }));
      return true;
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const newErrors = {};
        error.inner.forEach(err => {
          newErrors[err.path] = err.message;
        });
        setErrors(prevErrors => ({
          ...prevErrors,
          ...newErrors
        }));
      }
      return false;
    }
  }

  // ボタン押下 -------------------------------------------------------
  async function handleClickSave() {
    const isValid = await validateData(saveCondition);
    if (!isValid) {
      alert('入力不正項目があるため、確認をお願いいたします。');
      return;
    }
    if (screenMode === 1) {
      insert(saveCondition);
    } else if (screenMode === 2) {
      update(userId, saveCondition);
    }
  };

  // 登録 --------------------------------------------------------------
  async function insert (saveCondition) {
    try{
      await insertUser({
        loginId: saveCondition.loginId,
        password: saveCondition.password,
        name: saveCondition.name,
        kana: saveCondition.kana,
        type: saveCondition.type,
        shopId: saveCondition.shop,
        note: saveCondition.note
      });
      alert("登録が完了しました。");
      navigate(-1);
    } catch(error) {
      alert("登録に失敗しました。");
      console.log(error);
    }
  };

  // 更新 --------------------------------------------------------------
  async function update (userId, saveCondition) {
    const userData = {
      userId: userId,
      loginId: saveCondition.loginId,
      name: saveCondition.name,
      kana: saveCondition.kana,
      type: saveCondition.type,
      shopId: saveCondition.shop,
      note: saveCondition.note
    };
    if (saveCondition.password !== "・・・・") {
      userData.password = saveCondition.password;
    }
    try{
      await updateUser(userData);
      alert("更新が完了しました。");
      navigate(-1);
    } catch {
      alert("更新に失敗しました。");
    }
  };

  // 戻る --------------------------------------------------------------
  const handleClickReturn = (e) => {
    navigate(-1);
  };

  return (
    <CompanyTitledPage title="ユーザー管理">
      <SubTitle 
        screenMode={screenMode}
        onClickSave={handleClickSave}
        onClickReturn={handleClickReturn}
      />

      <Content
        saveCondition={saveCondition}
        setSaveCondition={setSaveCondition}
        errors={errors}
        validateData={validateData}
      />
    </CompanyTitledPage>
  );
};